import searchIcon from "../../assets/images/icon/search-icon.svg";
import { useEffect } from "react";
import { useDebounce } from "helpers/utils";

export default function SearchBar({
  placeholder,
  onSearch,
  title,
  query,
  setQuery,
}) {
  const debouncedQuery = useDebounce(query, 500);

  const handleSearch = e => {
    const value = e.target.value;
    setQuery(value);
  };

  useEffect(() => {
    onSearch(debouncedQuery);
  }, [debouncedQuery]);

  return (
    <div className="serach-bar-top">
      <form className="form-inline">
        <input
          className="form-control mr-sm-2"
          type="search"
          placeholder={placeholder}
          aria-label="Search"
          value={query}
          onChange={handleSearch}
          title={title}
        />
        <span>
          <img src={searchIcon} alt="search" />
        </span>
      </form>
    </div>
  );
}
